// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/scss/expendablecard.scss
// module id = 362
// module chunks = 2